import { render, staticRenderFns } from "./PaginationBrochuresGrid.vue?vue&type=template&id=788599ed&scoped=true&"
import script from "./PaginationBrochuresGrid.vue?vue&type=script&lang=js&"
export * from "./PaginationBrochuresGrid.vue?vue&type=script&lang=js&"
import style0 from "./PaginationBrochuresGrid.vue?vue&type=style&index=0&id=788599ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788599ed",
  null
  
)

export default component.exports